import script from "./followAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./followAdd.vue?vue&type=script&setup=true&lang=js"

import "./followAdd.vue?vue&type=style&index=0&id=a1d1117a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1d1117a"]])

export default __exports__